import {  dropFilenameExtension } from '../../utils/formatting';

export const defaultDocumentName = filename => {
  return dropFilenameExtension(filename)
    .replace(/[^a-z0-9]/gi, ' ')
    .replace(/\s\s+/g, ' ')
    .split(' ')
    .join(' ');
};
